<nh-form
  [individuals]="individuals"
  [formGroup]="getForm()"
  [mode]="mode"
  (validate)="onValidate($event)"
>
  @if (isRmbRmc) {
  <p>{{ "OTHER_COVERAGE_STATICTEXT14" | globalTranslate }}</p>
  }
  <h1 class="person-label">{{ selectedIndividual | fullname }}</h1>
  <section [formGroup]="getControl('data')">
    <nh-field
      id="tdo_hasTaxDependentOutside"
      label="{{ 'DOES_2' | globalTranslate }}{{
        selectedIndividual | fullname
      }} {{ 'TAX_DEPENDENTS_OUTSIDE_STATIC1' | globalTranslate }}"
      class="label-section"
    >
      <select
        nhTranslate
        name="hasTaxDependentOutside"
        [attr.aria-required]="true"
        [attr.aria-label]="
          ('DOES_2' | globalTranslate) +
          ' ' +
          (selectedIndividual | fullname) +
          ' ' +
          ('TAX_DEPENDENTS_OUTSIDE_STATIC1' | globalTranslate)
        "
        formControlName="hasTaxDependentOutside"
        [items]="tableCodeValue('YESNO', 'data.hasTaxDependentOutside')"
        (change)="hasTaxDependentsOutside()"
      ></select>
    </nh-field>
    <div (window:resize)="onResize($event)"></div>
    @if (isY('data.hasTaxDependentOutside')) {
    <div class="d-none d-lg-block">
      <h2 class="section-header">
        {{ "TAX_DEPENDENTS_OUTSIDE_STATIC2" | globalTranslate }}
      </h2>
      <hr />
      <table class="table w-100 table-striped">
        <thead>
          <tr>
            <th scope="col">
              {{ "TAX_DEPENDENTS_OUTSIDE_STATIC3" | globalTranslate }}
            </th>
            <th scope="col">{{ "DOB" | globalTranslate }}</th>
            <th scope="col">
              {{ "RELATIONSHIP_STATIC_TEXT3" | globalTranslate }}
              <span>{{ selectedIndividual | fullname }}</span>
            </th>
            <th scope="col">
              <span class="visually-hidden">Actions</span>
            </th>
          </tr>
        </thead>
        <tbody formArrayName="taxDependentsOutside">
          @for (dependent of taxDependentsOutside.controls; track dependent; let
          i = $index) {
          <tr [formGroupName]="i">
            <td>
              <nh-field
                [attr.aria-required]="true"
                id="tdo_name"
                [isRow]="true"
                [mandatory]="true"
              >
                <input
                  type="text"
                  class="form-control"
                  [attr.aria-label]="
                    'TAX_DEPENDENTS_OUTSIDE_STATIC3' | globalTranslate
                  "
                  formControlName="name"
                  name="name"
                  maxlength="45"
                  nh
                  (change)="dataChange()"
                />
              </nh-field>
            </td>
            <td>
              <nh-field
                [attr.aria-required]="false"
                id="tdo_birthDate"
                [isRow]="true"
                [mandatory]="false"
              >
                <nh-datepicker>
                  <input
                    type="text"
                    class="form-control"
                    [attr.aria-label]="'DOB' | globalTranslate"
                    (change)="isInvalidDate($event, dependent)"
                    [minDate]="minimumDate"
                    formControlName="birthDate"
                    [maxDate]="today"
                    bsDatepicker
                    nh
                    (change)="dataChange()"
                  />
                </nh-datepicker>
              </nh-field>
            </td>
            <td>
              <nh-field id="tdo_relation" [isRow]="true">
                <select
                  nhTranslate
                  name="relation"
                  formControlName="relation"
                  [attr.aria-label]="
                    ('RELATIONSHIP_STATIC_TEXT3' | globalTranslate) +
                    ' ' +
                    (selectedIndividual | fullname)
                  "
                  [items]="tableCodeValue('RELATIONTYPE', i)"
                  empty="Pick an option"
                ></select>
              </nh-field>
            </td>
            <td>
              @if (enableDeleteButton()) {
              <div class="pt-1 hover-red">
                <button
                  class="btn btn-link btn-lg delete-{{ i }} hover-red p-1"
                  (click)="removeAt(i)"
                >
                  <span class="pe-2">{{ "REMOVE" | globalTranslate }}</span>
                  <nh-remove-svg></nh-remove-svg>
                </button>
              </div>
              }
            </td>
          </tr>
          }
        </tbody>
      </table>
      <div class="pt-1 hover-red text-start">
        <button class="btn btn-link btn-lg hover-red" (click)="addRow()">
          <span class="pe-2">{{ "ADD_2" | globalTranslate }}</span>
          <nh-add-svg></nh-add-svg>
        </button>
      </div>
    </div>
    } @if (isY('data.hasTaxDependentOutside')) {
    <div class="nh-table-mobile mt-3 pt-2 d-lg-none">
      <div formArrayName="taxDependentsOutside">
        @for (dependent of taxDependentsOutside.controls; track dependent; let i
        = $index) {
        <div class="table-row mb-3 pb-3" [formGroupName]="i">
          <h2 class="section-header">
            {{ "TAX_DEPENDENTS_OUTSIDE_STATIC2" | globalTranslate }}
          </h2>
          <hr />
          <div class="mobile-table-header">
            {{ "TAX_DEPENDENTS_OUTSIDE_STATIC3" | globalTranslate }}
          </div>
          <hr />
          <div class="mobile-table-data">
            <nh-field
              [attr.aria-required]="true"
              id="tdo_name"
              [mandatory]="true"
            >
              <input
                type="text"
                class="form-control"
                [attr.aria-label]="
                  'TAX_DEPENDENTS_OUTSIDE_STATIC3' | globalTranslate
                "
                formControlName="name"
                name="name"
                nh
              />
            </nh-field>
          </div>
          <br />
          <div class="mobile-table-header">{{ "DOB" | globalTranslate }}</div>
          <hr />
          <div class="mobile-table-data">
            <nh-field
              [attr.aria-required]="false"
              id="tdo_birthDate"
              [mandatory]="false"
            >
              <nh-datepicker>
                <input
                  type="text"
                  class="form-control"
                  (change)="isInvalidDate($event, dependent)"
                  [minDate]="minimumDate"
                  formControlName="birthDate"
                  [attr.aria-label]="'DOB' | globalTranslate"
                  [maxDate]="today"
                  bsDatepicker
                  nh
                />
              </nh-datepicker>
            </nh-field>
          </div>
          <br />
          <div class="mobile-table-header">
            {{ "RELATIONSHIP_STATIC_TEXT3" | globalTranslate }}
            <span>{{ selectedIndividual | fullname }}</span>
          </div>
          <hr />
          <div class="mobile-table-data">
            <nh-field id="tdo_relation">
              <select
                nhTranslate
                name="relation"
                formControlName="relation"
                [attr.aria-label]="
                  ('RELATIONSHIP_STATIC_TEXT3' | globalTranslate) +
                  ' ' +
                  (selectedIndividual | fullname)
                "
                [items]="tableCodeValue('RELATIONTYPE', i)"
                empty="Pick an option"
              ></select>
            </nh-field>
          </div>
          <br />
          @if (enableDeleteButton()) {
          <div class="pt-1 hover-red text-center">
            <button
              class="btn btn-link btn-lg delete-{{ i }} hover-red p-1"
              (click)="removeAt(i)"
            >
              <span class="pe-2">{{ "REMOVE" | globalTranslate }}</span>
              <nh-remove-svg></nh-remove-svg>
            </button>
          </div>
          }<br />
        </div>
        }
      </div>
      <div class="pt-1 hover-red text-start">
        <button class="btn btn-link btn-lg hover-red" (click)="addRow()">
          <span class="pe-2">{{ "ADD_2" | globalTranslate }}</span>
          <nh-add-svg></nh-add-svg>
        </button>
      </div>
    </div>
    }
  </section>
</nh-form>